var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-group-row',{attrs:{"form":_vm.form,"label":_vm.label,"name":"password_confirmation","required":_vm.required}},[_c('form-input',{attrs:{"form":_vm.form,"name":"password_confirmation","type":"password"}}),(_vm.hint)?_c('span',{staticClass:"help-block text-muted"},[_vm._v(_vm._s(_vm.hint))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }